import { BrowserRouter } from 'react-router-dom';
import React from 'react';
import ReactDOM, { hydrate } from 'react-dom';
import { ensureReady, After } from '@jaredpalmer/after';
import routes from './routes';

if (process.env.NODE_ENV !== 'production') {
  var axe = require('react-axe');
  axe(React, ReactDOM, 1000);
}

ensureReady(routes).then((data) =>
  hydrate(
    <BrowserRouter>
      <After data={data} routes={routes} />
    </BrowserRouter>,
    document.getElementById('root')
  )
);

if (module.hot) {
  module.hot.accept();
}
